import config from "@/config"
import axios from '@/plugins/axios';
import router from '@/Routes'
import store from '@/store';
import * as authMixin from '@/mixins/auth';
import * as userApi from '@/api/user';

export default {
  namespaced: true,
  state: {
    isFetching: false,
    errorMessage: '',
    isRetryConfirm: false,
  },
  mutations: {
    LOGIN_FAILURE(state, payload) {
      state.isFetching = false;
      state.errorMessage = payload.errorMessage;
      state.isRetryConfirm = payload.isRetryConfirm !== undefined ? payload.isRetryConfirm : false;
    },
    LOGIN_SUCCESS(state) {
      state.isFetching = false;
      state.errorMessage = '';
      state.isRetryConfirm = false;
    },
    LOGIN_REQUEST(state) {
      state.isFetching = true;
      state.errorMessage = '';
    },
    DISABLE_RETRY_CONFIRM(state){
      state.isRetryConfirm = false;
    },
  },
  actions: {
    checkAuth(){
      return authMixin.isAuthenticatedWithToken();
    },
    async loginUser({dispatch}, creds) {
      if (!config.isBackend) {
        dispatch('receiveToken', 'token');
        return Promise.resolve();
      } else {
        await dispatch('requestLogin');
        try{
          let {data} = await axios.post("/auth/login", creds, {silence401: true})
          await dispatch('receiveToken', data.access_token);
          return Promise.resolve();
        }catch (err) {
          if(err.response.data && err.response.data.error){
            dispatch('loginError', {
              errorMessage: err.response.data.error,
              isRetryConfirm: err.response.data.is_show_btn_retry_confirm !== undefined ? err.response.data.is_show_btn_retry_confirm : false
            });
          }else{
            dispatch('loginError', {errorMessage: 'Ошибка авторизации'});
          }
          return Promise.reject(err);
        }
        // if (creds.social) {
        //   window.location.href = config.baseURLApi + "/auth/login" + creds.social + '?app=' + config.redirectUrl;
        // }else if (creds.email.length > 0 && creds.password.length > 0) {
        //   axios.post("/auth/login", creds, {silence401: true}).then(res => {
        //     const token = res.data.access_token;
        //     dispatch('receiveToken', token);
        //   }).catch(err => {
        //     console.log(err);
        //     if(err.response.data && err.response.data.error){
        //       dispatch('loginError', {
        //         errorMessage: err.response.data.error,
        //         isRetryConfirm: err.response.data.is_show_btn_retry_confirm !== undefined ? err.response.data.is_show_btn_retry_confirm : false
        //       });
        //     }else{
        //       dispatch('loginError', {errorMessage: 'Ошибка авторизации'});
        //     }
        //   })
        // } else{
        //   dispatch('loginError', {errorMessage: 'Ошибка авторизации. Повторите попытку'});
        // }
      }
    },
    receiveToken({dispatch}, token) {
      authMixin.setAuthData(token);
      dispatch('receiveLogin');
    },
    clearToken(){
      authMixin.clearAuthData();
    },
    async logoutUser({dispatch}) {
      let isAuth = await dispatch('checkAuth');
      if(isAuth){
        try{
          await userApi.logout()
        }catch(err){
          console.log(err);
        }
      }
      dispatch('clearToken');
      document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      store.dispatch('user/CLEAR_USER');
      // axios.defaults.headers.common['Authorization'] = "";
      // router.push('/login').then(() => window.location = '/');
      router.push('/login');
    },
    refresh(){
      userApi.refresh();
    },
    loginError({commit}, payload) {
      commit('LOGIN_FAILURE', payload);
    },
    receiveLogin({commit}) {
      commit('LOGIN_SUCCESS');
      // router.push({name: 'Main'});
    },
    requestLogin({commit}) {
      commit('LOGIN_REQUEST');
    },
    disableRetryConfirm({commit}){
      commit('DISABLE_RETRY_CONFIRM');
    }
  }
}
